import { first } from 'lodash'

// Return the root path (namespace) from a Post's full path

function getPostRootPath(fullPath) {
  return first(fullPath.match(/.+?(?=discussions)/g))
}

export default getPostRootPath
